module.exports = __webpack_public_path__ + "static/bonfire-logo-a20440dbe78f7b27bfc419b57d741aae.png";